export const ADMIN_USER_NAME = 'admin';
export const ADMIN_GROUP_NAME = 'admin';
export const BREADCRUMBS_BAR_PORTAL_ID = 'breadcrumbs-bar';
export const DEFAULT_ITEMS_PER_PAGE = 8;
export const QUERY_KEY_KEYWORD = 'q';
export const QUERY_KEY_TAGS = 't';
export const QUERY_KEY_NODE_STATUS_FILTER = 'n';
export const QUERY_KEY_PAGE = 'p';
export const QUERY_KEY_PERPAGE = 'perPage';
